export default function timeago(label: string): string {
  return label
    .replace('just now', 'agora mesmo')
    .replace('minute', 'minuto')
    .replace('hour', 'hora')
    .replace('day', 'dia')
    .replace('ago', 'atras')
    .replace('atrasra', 'agora')
    .replace('second', 'segundo')
}
